<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    @if (page) {
      <section>
        <div class="card">
          <div class="row">
            <div class="col-6">
              <div class="show-entries-container">
                <label
                  >Zeige
                  <ng-select
                    [clearable]="false"
                    [searchable]="false"
                    [formControl]="filter.get('limit') | formControl">
                    <ng-option [value]="10">10</ng-option>
                    <ng-option [value]="25">25</ng-option>
                    <ng-option [value]="50">50</ng-option>
                    <ng-option [value]="100">100</ng-option>
                  </ng-select>
                  Einträge</label
                >
              </div>
            </div>
            <div class="col-6">
              <div class="datatable-add-button">
                <button
                  type="button"
                  rippleEffect
                  (click)="openModal()">
                  <i
                    data-feather="plus"
                    class="datatable-add-button-icon"></i
                  ><span class="datatable-add-button-text">Betreuer:in hinzufügen</span>
                </button>
              </div>
            </div>
          </div>
          <ngx-datatable
            [rows]="page.items"
            [reorderable]="false"
            rowHeight="auto"
            class="bootstrap core-bootstrap"
            columnMode="force"
            [scrollbarH]="true"
            [count]="page.totalItems ?? 0"
            [offset]="page.currentPage - 1"
            [limit]="page.itemsPerPage"
            [externalPaging]="true"
            (page)="setPage($event)"
            [externalSorting]="true"
            (sort)="onSort($event)">
            <ngx-datatable-column
              [width]="75"
              prop="id"
              name=""
              [sortable]="false">
              <ng-template
                let-value="value"
                let-row="row"
                ngx-datatable-cell-template>
                <div class="datatable-buttons">
                  @if (!row.deletedAt){
                    <a
                      title="bearbeiten"
                      [routerLink]="[]"
                      [queryParams]="getOpenModalParams(value)"
                      class="clickable-icon">
                      <i data-feather="edit"></i>
                    </a>
                    <div
                      title="löschen"
                      class="clickable-icon-danger"
                      (click)="delete(value)">
                      <i data-feather="trash"></i>
                    </div>
                  }@else{
                    @if (CaslAction.Restore | permission: EntityTyp.Employee){
                      <div
                        title="Wiederherstellen"
                        class="clickable-icon"
                        (click)="restore(value)">
                        <i data-feather="plus-circle"></i>
                      </div>
                    }
                  }
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="lastName"
              name="Nachname">
              <ng-template
                let-column="column"
                ngx-datatable-header-template
                let-sort="sortFn"
                let-sortDir="sortDir">
                <love-it-list-header-cell
                  [column]="column"
                  [sortFunc]="sort"
                  [sortDir]="sortDir"></love-it-list-header-cell>
                <love-it-filter-input [filterFormControl]="filter.get('lastName') | formControl"></love-it-filter-input>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="firstName"
              name="Vorname">
              <ng-template
                let-column="column"
                ngx-datatable-header-template
                let-sort="sortFn"
                let-sortDir="sortDir">
                <love-it-list-header-cell
                  [column]="column"
                  [sortFunc]="sort"
                  [sortDir]="sortDir"></love-it-list-header-cell>
                <love-it-filter-input
                  [filterFormControl]="filter.get('firstName') | formControl"></love-it-filter-input>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="offices"
              name="Standorte"
              [sortable]="false">
              <ng-template
                let-column="column"
                ngx-datatable-header-template
                let-sort="sortFn"
                let-sortDir="sortDir">
                <love-it-list-header-cell
                  [column]="column"
                  [sortFunc]="sort"
                  [sortDir]="sortDir"></love-it-list-header-cell>
                <ng-select
                  [items]="offices"
                  [formControl]="filter.get('officeId') | formControl"
                  bindValue="id"
                  bindLabel="name"></ng-select>
              </ng-template>
            </ngx-datatable-column>
            @if (authService.currentUserValue?.role === UserRole.Admin) {
              <ngx-datatable-column
                prop="deletedAt"
                name="Gelöscht"
                [sortable]="false">
                <ng-template
                  let-column="column"
                  ngx-datatable-header-template
                  let-sort="sortFn"
                  let-sortDir="sortDir">
                  <love-it-list-header-cell
                    [column]="column"
                    [sortFunc]="sort"
                    [sortDir]="sortDir"></love-it-list-header-cell>
                  <love-it-select-boolean
                    [booleanFc]="filter.get('deleted') | formControl"
                  ></love-it-select-boolean>
                </ng-template>
                <ng-template
                  ngx-datatable-cell-template
                  let-value="value">
                  <love-it-display-boolean [value]="value"></love-it-display-boolean>
                </ng-template>
              </ngx-datatable-column>
            }
          </ngx-datatable>
        </div>
      </section>
    }
  </div>
</div>
